<template>
  <div class="declaracao-latam page-break-inside-avoid border-1 border-black">
    <div class="latam-header flex items-center justify-between px-4 py-2">
      <img
        src="/images/shipping-companies/latamcargo.png"
        alt="Logo da Latam Cargo"
        class="logo"
      >

      <h1 class="text-lg uppercase">Declaração de Conteúdo</h1>
    </div>

    <ul class="list-section">
      <li class="list-section__item bg-neutral-light">
        <h2 class="text-small font-bold text-center uppercase">Remetente</h2>
      </li>

      <li class="list-section__item">
        <p class="text-xs">
          <strong class="font-bold uppercase">Nome:</strong> {{ order.from.name }}
        </p>
      </li>

      <li class="list-section__item">
        <p class="text-xs">
          <strong class="font-bold uppercase">CPF/CNPJ:</strong> {{ order.from.company_document || order.from.document }}
        </p>
      </li>

      <li class="list-section__item">
        <p class="text-xs">
          <strong class="font-bold uppercase">Endereço:</strong> {{ order.from.address }}
        </p>
      </li>

      <li class="list-section__item list-section__item--grid">
        <p class="text-xs">
          <strong class="font-bold uppercase">Cidade:</strong> {{ order.from.city }}
        </p>

        <p class="text-xs uppercase">
          <strong class="font-bold">UF:</strong> {{ order.from.state_abbr }}
        </p>

        <p class="text-xs">
          <strong class="font-bold uppercase">CEP:</strong> {{ order.from.postal_code }}
        </p>
      </li>
    </ul>

    <ul class="list-section">
      <li class="list-section__item bg-neutral-light">
        <h2 class="text-small font-bold text-center uppercase">Destinatário</h2>
      </li>

      <li class="list-section__item">
        <p class="text-xs">
          <strong class="font-bold uppercase">Nome:</strong> {{ order.to.name }}
        </p>
      </li>

      <li class="list-section__item">
        <p class="text-xs">
          <strong class="font-bold uppercase">CPF/CNPJ:</strong> {{ order.to.company_document || order.to.document }}
        </p>
      </li>

      <li class="list-section__item">
        <p class="text-xs">
          <strong class="font-bold uppercase">Endereço:</strong> {{ order.to.address }}
        </p>
      </li>

      <li class="list-section__item list-section__item--grid">
        <p class="text-xs">
          <strong class="font-bold uppercase">Cidade:</strong> {{ order.to.city }}
        </p>

        <p class="text-xs uppercase">
          <strong class="font-bold">UF:</strong> {{ order.to.state_abbr }}
        </p>

        <p class="text-xs">
          <strong class="font-bold uppercase">CEP:</strong> {{ order.to.postal_code }}
        </p>
      </li>
    </ul>

    <ul class="list-section">
      <li class="list-section__item bg-neutral-light">
        <h2 class="text-small font-bold text-center uppercase">Identificação da Carga</h2>
      </li>

      <li class="list-section__item list-section__item--grid text-center text-xs font-bold">
        <strong class="flex flex-col justify-center">
          Item
        </strong>

        <strong class="flex flex-col justify-center">
          Quant.
          <span>Itens</span>
        </strong>

        <strong class="flex flex-col justify-center">
          Valor Unit.
          <span class="block">(R$/un)</span>
        </strong>
      </li>

      <li
        v-for="(product, index) in products"
        :key="index"
        class="list-section__item list-section__item--grid"
      >
        <p class="flex items-center text-xs">{{ product.name }}</p>
        <p class="flex items-center text-xs">{{ product.quantity || '' }}</p>
        <p class="flex items-center text-xs">{{ product.name && beautifyNumberToBRL(product.unitary_value) }}</p>
      </li>

      <li class="list-section__item list-section__item--grid text-xs font-bold">
        <strong class="text-right">Totais</strong>

        <strong>{{ totalQuantity }}</strong>

        <strong>{{ beautifyNumberToBRL(totalValue) }}</strong>
      </li>

      <li class="list-section__item list-section__item--grid text-xs font-bold">
        <strong class="text-right">Peso Total</strong>

        <strong>{{ numberToBRL(totalWeight) }}kg</strong>
      </li>
    </ul>

    <ul class="list-section">
      <li class="list-section__item bg-neutral-light border-b border-black">
        <h2 class="text-small font-bold text-center uppercase">Declaração</h2>
      </li>
    </ul>

    <div class="p-1">
      <p class="mb-3 text-xxs">
        Declaro que não me enquadro no conceito de contribuinte previsto no art. 4º da Lei Complementar nº 87/1996,
        uma vez que não realizo, com habitualidade ou em volume que caracterize intuito comercial, operações de circulação de mercadoria,
        ainda que se iniciem no exterior, ou estou dispensado da emissão da nota fiscal por força da legislação tributária vigente,
        responsabilizando-me, nos termos da lei e a quem de direito, por informações inverídicas.
      </p>

      <p class="mb-3 text-xxs">
        Declaro ainda que não estou enviando dinheiro em espécie, artigo proibido ou artigo perigoso não declarado e que, por medidas de
        segurança, autorizo a abertura das remessas de volumes em caso de necessidade.
      </p>

      <p class="mb-3 text-xxs">
        Por fim, declaro estar de acordo com as Condições do Contrato de Transporte - Código Brasileiro da Aeronáutica
        (Lei n.º 7.565, de dezembro de 1986).
      </p>

      <p class="mb-8 text-xxs">
        <strong class="font-bold">Observação:</strong> Constitui crime contra a ordem tributária suprimir ou reduzir tributo,
        ou contribuição social e qualquer acessório (Lei 8.137/90 Art. 1º, V).
      </p>

      <div class="flex justify-center mx-auto mb-12">
        <p class="signature-block signature-block--xs" data-content="(Localidade)"></p>

        <p>,</p>

        <div class="signature-block signature-block--md signature-block--borderless flex ml-1" data-content="(Data)">
          <p class="signature-block signature-block--sm"></p>

          <p>/</p>

          <p class="signature-block signature-block--sm"></p>

          <p>/</p>

          <p class="signature-block signature-block--sm"></p>
        </div>
      </div>

      <p class="signature-block mx-auto mb-8" data-content="(Assinatura)"></p>
    </div>
  </div>
</template>

<script>
import contentDeclaration from 'commons/js/mixins/contentDeclaration';

export default {
  mixins: [
    contentDeclaration(),
  ],
};
</script>

<style lang="stylus" scoped>
$logo-width = 119px
$logo-height = 37px
$list-section-columns = 4

.declaracao-latam
  font-family 'Trebuchet MS', Arial, sans-serif
  print-color-adjust exact
  -webkit-print-color-adjust exact

  .latam-header
    &::after
      content ''
      width $logo-width

  .logo
    width $logo-width
    height $logo-height

  .list-section
    &__item
      border-top 1px solid black

      > *:not(.p-0)
        padding 5px 4px

      &--grid
        display grid
        grid-template-columns 1fr 15% 25%
        grid-template-rows minmax(26px, 1fr)

        > *:not(:first-child)
          border-left 1px solid black

  .signature-block
    width 50%
    position relative

    &--xs
      width 25%

    &--sm
      width 33%

    &--md
      width 40%

    &:not(&--borderless)
      border-bottom 1px solid black

    &::after
      content attr(data-content)
      margin-top 2px
      position absolute
      top 100%
      left 50%
      translate -50% 0
      font-size 0.65rem
</style>
